import { Component, OnInit } from '@angular/core';
import { Modal, overlayConfigFactory } from 'ngx-modialog';
import { switchMap } from 'rxjs/operator/switchMap';
import { map } from 'rxjs/operators';
import { ApiService } from '../../../../utils/services/api.service';
import { FreeHotelModalComponent } from '../free-hotel-modal/free-hotel-modal.component';
import { BSModalContext } from 'ngx-modialog/plugins/bootstrap';
import { ActivatedRoute } from '@angular/router';
import { NotificationsService } from 'angular2-notifications';

@Component({
  selector: 'app-hotel-changes-item',
  templateUrl: './hotel-changes-item.component.html',
  styleUrls: ['./hotel-changes-item.component.scss']
})
export class HotelChangesItemComponent implements OnInit {
  hotelChanges = [];
  lastHotels = []
  hotels = [];
  pendingIds = [];
  hotelsById = {};
  isLoading = false;
  hotelId;
  last;
  hotelChangeItem;

  constructor(private notificationsService: NotificationsService, private apiService: ApiService, public modal: Modal, private activatedRoute: ActivatedRoute) { }

  ngOnInit() {
    this.hotelId = this.activatedRoute.snapshot.params.hotelId;
    this.apiService.getHotelChangesById(this.hotelId).subscribe(res => {
      this.last = res.data
    })
    this.apiService.getHotelLast(this.hotelId).subscribe(res => {
      this.hotelChangeItem = res.data.rows[0]
    })
    console.log(this.hotelId)
  }

  getHotelChanges() {
    this.isLoading = true;
    this.apiService.getHotelChanges().switchMap(hotelChangeResponse => {
      if (hotelChangeResponse) {
        this.pendingIds = [];
        this.hotelChanges = hotelChangeResponse.data;
        this.hotelChanges.forEach(ids => {
          this.pendingIds.push(ids.hotelId)
        });
        return this.apiService.getHotelLast(this.pendingIds)
      }

    }).subscribe(hotelRes => {
      hotelRes.data.rows.forEach(hotel => {
        this.hotelsById[hotel.id] = hotel;
      });

      this.hotelChanges.forEach(changeItem => {
        changeItem.oldHotel = this.hotelsById[changeItem.hotelId];
      })

      this.isLoading = false;

    })

  }

  setApprove(hotelOrgId, hotelId, status) {
    let dialogRef = this.modal.open(
      FreeHotelModalComponent,
      overlayConfigFactory({
        size: 'md',
        hotelOrgId: hotelOrgId,
        hotelId: hotelId,
        status: status == 'reject' ? 'Rejected' : 'Accepted',
        isAgencyView: true
      }, BSModalContext));
    dialogRef.result.then((result) => {
      if (result.affectedRowCount == 1) {
        this.last = null

      }
    });
  }

}


// WEBPACK FOOTER //
// C:/Biziclick/bizisystem/src/app/main/pages/free-hotel-changes/hotel-changes-item/hotel-changes-item.component.ts